import getConfig from 'next/config'
const { publicRuntimeConfig, serverRuntimeConfig } = getConfig()

export const getAddressConfigByCountry = async (country) => {
  try {
    const apiUrl = `${publicRuntimeConfig.userResourcesApiBaseUrl}/api/v1/address/addressConfigByCountry/${country}`
    const response = await fetch(apiUrl, {
      method: 'GET',
      credentials: 'include'
    })
    if (!response.ok) {
      throw `getAddressConfigByCountry failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const provisionSFDCUser = async () => {
  try {
    const apiUrl = `${publicRuntimeConfig.userResourcesApiBaseUrl}/api/v1/supportTickets/provisionUser`
    const response = await fetch(apiUrl, {
      method: 'POST'
    })
    if (!response.ok) {
      throw `provisionSFDCUser failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const createSFDCSamlRequest = async () => {
  try {
    const apiUrl = `${publicRuntimeConfig.userResourcesApiBaseUrl}/api/v1/supportTickets/createSamlRequest`
    const response = await fetch(apiUrl, {
      method: 'POST'
    })
    if (!response.ok) {
      throw `createSFDCSamlRequest failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const createSFDCSamlRequestServer = async (cookie) => {
  try {
    const apiUrl = `${serverRuntimeConfig.userResourcesApiBaseUrl}/api/v1/supportTickets/createSamlRequest`
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: cookie && {
        Cookie: cookie
      }
    })
    if (!response.ok) {
      throw `createSFDCSamlRequest failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getSFDCProvisionStatusServer = async (cookie) => {
  try {
    const apiUrl = `${serverRuntimeConfig.userResourcesApiBaseUrl}/api/v1/supportTickets/provisionStatus`
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: cookie && {
        Cookie: cookie
      }
    })
    if (!response.ok) {
      throw `getSFDCProvisionStatusServer failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getUserDashboardState = async (cookie) => {
  try {
    const apiUrl = `${publicRuntimeConfig.userResourcesApiBaseUrl}/api/v1/dashboard`
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: cookie && {
        Cookie: cookie
      }
    })
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getUserDashboardStateServer = async (cookie) => {
  try {
    const apiUrl = `${serverRuntimeConfig.userResourcesApiBaseUrl}/api/v1/dashboard`
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: cookie && {
        Cookie: cookie
      }
    })
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getRegionPrivacyPolicyTypeServer = async () => {
  try {
    const apiUrl = `${serverRuntimeConfig.legalApiBaseUrl}/api/v1/legalTypes/region`
    const response = await fetch(apiUrl, {
      method: 'GET'
    })
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getKnoxManageApprovedRedirectServer = async (cookie) => {
  try {
    const apiUrl = `${serverRuntimeConfig.userResourcesApiBaseUrl}/api/v1/knoxManage/redirect`
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: cookie && {
        Cookie: cookie
      }
    })
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getBasicDownloadLink = async (resourceId) => {
  try {
    const apiUrl = `${publicRuntimeConfig.userResourcesApiBaseUrl}/api/v1/basicDownload/${resourceId}`
    const response = await fetch(apiUrl, {
      method: 'GET',
      credentials: 'include'
    })
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getLatestKmeDirectResources = async (cookie) => {
  try {
    const apiUrl = `${serverRuntimeConfig.userResourcesApiBaseUrl}/api/v1/kmeDirectResource/latest`
    const response = await fetch(apiUrl, {
      method: 'GET',
      credentials: 'include',
      headers: cookie && {
        Cookie: cookie
      }
    })
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getAuditLogActionsList = () => {
  const actionsLookup = {
    ProfileUpdate: 'Profile update',
    LegalAgreement: 'Legal agreement',
    KPAccountEnrollment: 'KP account enrollment',
    B2BEnrollment: 'B2B service enrollment',
    CheckLicenseTool: 'Check license tool',
    DeviceDeactivationTool: 'Device deactivation tool',
    BBDeviceDeactivationTool: 'Blackberry device deactivation tool',
    EEDevicesGenerateLicense: 'EE devices generate license',
    EEDevicesApproved: 'EE devices application approved',
    EEDevicesRejected: 'EE devices application rejected',
    EEAutoAppendSetPreference: 'EE auto-append set preference',
    GdprUserDeleteAccount: 'GDPR User delete account request',
    GdprUserDeleteData: 'GDPR User delete data',
    GdprUserExportData: 'GDPR User export data',
    GdprAdminDeleteAction: 'GDPR Admin delete action',
    GdprSystemDeleteAction: 'Automatic GDPR System delete action',
    GdprAdminAction: 'GDPR Admin action',
    EfotaOnMdmTrial: 'E-FOTA on MDM Trial',
    EfotaAdvanced: 'E-FOTA Advanced',
    KnoxManageApproved: 'Knox Manage application approved',
    KnoxManageRejected: 'Knox Manage application rejected',
    KnoxManageBlocked: 'Knox Manage application blocked',
    KnoxManageDeleted: 'Knox Manage application deleted',
    KnoxManageAmsMigration: 'Knox Manage user AMS migration',
    BasicDownloadFiles: 'Knox Basic file download',
    UserEnrolment: 'User Enrolment',
    UserMarketingOptInOut: 'User Marketing Opt In Out',
    LegalAgreementAccepted: 'Legal Agreement Accepted',
    TenantUpdated: 'Tenant Updated',
    EEAppendLicense: 'EE devices append license',
    EEMergeLicense: 'EE devices merge license',
    EEUpdateAssociatedLicenseReseller: 'EE update associated license reseller',
    EEAutoAppend: 'EE auto append'
  }
  return actionsLookup
}

export const getMaintenanceMode = async (cookie) => {
  try {
    const apiUrl = `${serverRuntimeConfig.userResourcesApiBaseUrl}/api/v1/maintenanceMode`
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: cookie && {
        Cookie: cookie
      }
    })
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getSmrHidden = async (cookie) => {
  try {
    const apiUrl = `${serverRuntimeConfig.userResourcesApiBaseUrl}/api/v1/smrHidden`
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: cookie && {
        Cookie: cookie
      }
    })
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getNewCaptureFlag = async (cookie) => {
  try {
    const apiUrl = `${serverRuntimeConfig.userResourcesApiBaseUrl}/api/v1/newCaptureFlag`
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: cookie && {
        Cookie: cookie
      }
    })
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}
